// extracted by mini-css-extract-plugin
export default {"section":"Support_section__DlMB-"};